// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3580": "51788fc3b1f7","4259": "04416507f20e","6863": "454c9f289029","8357": "dd422574e14d","9740": "ad6e017ed1cd",}[chunkId] + ".css"
}